import { render, staticRenderFns } from "./DynamicBl.vue?vue&type=template&id=19a03a23&scoped=true&"
import script from "./DynamicBl.vue?vue&type=script&lang=js&"
export * from "./DynamicBl.vue?vue&type=script&lang=js&"
import style0 from "./DynamicBl.vue?vue&type=style&index=0&id=19a03a23&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a03a23",
  null
  
)

/* custom blocks */
import block0 from "./DynamicBl.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports